import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from "../../environments/environment";
import { UserService } from './user-service';


@Injectable({ providedIn: 'root' })
export class AuthService {
    private http = inject(HttpClient);
    private apiUrl = environment.apiUrl + '/auth';
    private userService = inject(UserService);


    redirectToProvider(provider: 'google' | 'linkedin') {

        switch (provider) {
            case 'google':
                this.redirectToGoogle();
                break;
            case 'linkedin':
                this.redirectToLinkedIn();
                break;
        }
    }

    redirectToLinkedIn() {
        const clientId = environment.linkedinClientId;
        const redirectUri = encodeURIComponent(environment.linkedinRedirectUri);
        const scope = 'openid%20profile%20email';
        const state = 'un_code_aleatoire_pour_la_securite'; // Optionnel mais recommandé

        window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`;
    }

    // 2. Envoyer le code au Back-end
    handleLinkedinCallback(code: string) {
        return this.http.post(`${this.apiUrl}/linkedin`, { code })
            .pipe(
                tap(() => {
                    this.userService.me().subscribe(); // Récupérer le profil après login
                })
            );
    }

    redirectToGoogle() {
        const clientId = environment.googleClientId;
        const redirectUri = encodeURIComponent(environment.googleRedirectUri);
        const scope = 'openid%20profile%20email';
        const state = 'un_code_aleatoire_pour_la_securite'; // Optionnel mais recommandé

        window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`;
    }

    handleGoogleCallback(code: string) {
        return this.http.post(`${this.apiUrl}/google`, { code })
            .pipe(
                tap(() => {
                    this.userService.me().subscribe(); // Récupérer le profil après login
                })
            );
    }

    logout(): Observable<any> {
        return this.http.post(`${this.apiUrl}/logout`, {});
    }

    refreshToken(): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/refresh-token`, {});
    }
}